/**
 * @generated SignedSource<<7cd0d1002dac5ef380923db3776416e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductDateTrackerHistoryList_Store$data = {
  readonly id: string;
  readonly productExpireBatchesHistory: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"ProductExpireBatchListItemContent_StoreProductExpireBatch">;
      };
    }>;
  } | null;
  readonly " $fragmentType": "ProductDateTrackerHistoryList_Store";
};
export type ProductDateTrackerHistoryList_Store$key = {
  readonly " $data"?: ProductDateTrackerHistoryList_Store$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductDateTrackerHistoryList_Store">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "productExpireBatchesHistory"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./ProductDateTrackerHistoryListPaginationQuery.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "ProductDateTrackerHistoryList_Store",
  "selections": [
    {
      "alias": "productExpireBatchesHistory",
      "args": null,
      "concreteType": "StoreProductExpireBatchConnection",
      "kind": "LinkedField",
      "name": "__ProductDateTrackerHistory__productExpireBatchesHistory_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StoreProductExpireBatchEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "StoreProductExpireBatch",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ProductExpireBatchListItemContent_StoreProductExpireBatch"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "Store",
  "abstractKey": null
};
})();

(node as any).hash = "dae52e6bea7d5fc6f8cf316f89c0b61f";

export default node;
